module.exports = __webpack_public_path__ + "img/united-states-of-america.6fe12bb6.png";